<div class="app-list-table">
  <div class="app-list-header"
       *ngIf="!hideHeader"
       fxLayout="row"
       fxLayoutAlign="start center"
       fxLayoutGap="8px"
       fxLayoutGap.gt-xs="24px">
    <div *ngIf="!hasFilter" class="app-list-name">{{ name }}</div>
    <div *ngIf="form && hasFilter" class="app-list-name">
      <form [formGroup]="form">
        <mat-form-field class="system-form-field" fxFlex style="margin-top: 15.5px;">
          <mat-label>Buscar por:</mat-label>
          <mat-select formControlName="search" [panelClass]="'panel-system'">
            <mat-option *ngFor="let filt of filterArray" value="{{filt.id}}">{{filt.name}}</mat-option>
          </mat-select>

        </mat-form-field>

        <div fxLayout="row" fxLayoutAlign="start center" fxFlex>
          <mat-form-field fxFlex style="margin-top: 15.5px; margin-left: 7.5px;" class="system-form-field mat-date-default">
            <mat-label>Fecha Inicial</mat-label>
            <input matInput formControlName="startDate" [matDatepicker]="startDate" [max]="today">
            <mat-datepicker-toggle matIconSuffix [for]="startDate"></mat-datepicker-toggle>
            <mat-datepicker #startDate panelClass="panel-system"></mat-datepicker>
          </mat-form-field>

          <mat-form-field *ngIf="maxDays == 0" fxFlex style="margin-top: 15.5px; margin-left: 7.5px;" class="system-form-field mat-date-default">
            <mat-label>Fecha Final</mat-label>
            <input matInput formControlName="endDate" [matDatepicker]="endDate" [max]="today" [min]="maxDate">
            <mat-datepicker-toggle matIconSuffix [for]="endDate"></mat-datepicker-toggle>
            <mat-datepicker #endDate panelClass="panel-system"></mat-datepicker>
          </mat-form-field>

          <mat-form-field *ngIf="maxDays != 0" fxFlex style="margin-top: 15.5px; margin-left: 7.5px;" class="system-form-field mat-date-default">
            <mat-label>Fecha Final</mat-label>
            <input matInput formControlName="endDate" [matDatepicker]="endDate" [max]="verifyStart()" [min]="maxDate">
            <mat-datepicker-toggle matIconSuffix [for]="endDate"></mat-datepicker-toggle>
            <mat-datepicker #endDate panelClass="panel-system"></mat-datepicker>
          </mat-form-field>
        </div>

      </form>
    </div>

    <div [ngStyle]="{'visibility':!hasDates ? 'visible' : 'hidden'}" fxLayout="row" fxLayoutAlign="start center" fxFlex>
      <mat-icon *ngIf="!hideFilter" class="app-filter-input-icon">search</mat-icon>
      <input *ngIf="!hideFilter" fxFlex class="app-filter-input" #filter placeholder="Buscar&hellip;">
    </div>

    <button class="app-column-filter" type="button" mat-icon-button [matMenuTriggerFor]="columnFilter">
      <mat-icon>filter_list</mat-icon>
    </button>
    <ng-content select=".actions"></ng-content>
    <button *ngIf="searchBut" type="button" mat-raised-button color="primary" (click)="sendSearchButton()" [disabled]="!form?.valid">
      Buscar
    </button>
    <button *ngIf="addDownload" type="button" [disabled]="!dataInTable" mat-raised-button color="primary" (click)="sendReporthButton()">
      Exportar Excel
    </button>
  </div>

  <mat-menu #columnFilter="matMenu" yPosition="below" xPosition="before" class="panel-system checkbox-hide-table">
    <button class="checkbox-item mat-menu-item" *ngFor="let column of columns"
            (click)="toggleColumnVisibility(column, $event)">
      <mat-checkbox [(ngModel)]="column.visible" class="checkbox" #checkbox (click)="$event.stopPropagation()">
        {{ column.name }}
      </mat-checkbox>
    </button>
  </mat-menu>

  <ng-content></ng-content>
</div>
